const types = {
    STUDENT_SELECTION_IN_HIGHLIGHT: 'STUDENT_SELECTION_IN_HIGHLIGHT',
    STUDENT_HAS_VALID_SELECTION: 'STUDENT_HAS_VALID_SELECTION',
    ANNOTATING_CONTENT: 'ANNOTATING_CONTENT',
    FOCUSED_ANNOTATION: 'FOCUSED_ANNOTATION',
    ANNOTATION_LIST: 'ANNOTATION_LIST',
    ANNOTATION_VISIBILITY: 'ANNOTATION_VISIBILITY',
};

const studentHighlightsActions = {
    types,
    setIsSelectionInHighlight(selectionInHighlight) {
        if (typeof selectionInHighlight === 'boolean') {
            return { type: types.STUDENT_SELECTION_IN_HIGHLIGHT, selectionInHighlight };
        }
        throw new Error('Non boolean passed to setIsSelectionInHighlight().');
    },

    setHasValidSelection(hasValidSelection) {
        if (typeof hasValidSelection === 'boolean') {
            return { type: types.STUDENT_HAS_VALID_SELECTION, hasValidSelection };
        }
        throw new Error('Non boolean passed to setHasValidSelection().');
    },

    setAnnotatingContent(annotatingContentId, annotatingContentType) {
        return { type: types.ANNOTATING_CONTENT, annotatingContentId, annotatingContentType };
    },

    setFocusedAnnotation(annotationSelector) {
        return { type: types.FOCUSED_ANNOTATION, annotationSelector };
    },

    setAnnotationList(annotationList) {
        return { type: types.ANNOTATION_LIST, annotationList };
    },

    setAnnotationsVisibility(annotationsVisibility) {
        return { type: types.ANNOTATION_VISIBILITY, annotationsVisibility };
    },
};

export default studentHighlightsActions;
